$( ".pagina" ).each(function() {
    $( this ).show();
    id = $( this ).attr("pageid");
    if(id != 1){
        $( this ).hide();
    }
});

$('.showPage').click(function () {
    var page = this.id;
    var idlink = this.name;
    //location.href = '#products';
    $( ".linkpg" ).each(function() {
        $( this ).removeClass('active');
    });
    $( '#pg'+idlink ).addClass("active");
    $( ".pagina" ).each(function() {
        $( this ).show();
        var id = $( this ).attr("pageid");
        if(id != page){
            $( this ).hide();
        }
    });
});